import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VideoType } from '@core/enums/video-type';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FeaturedVideo } from '@modules/home/models/featured-video';
import { TranslateModule } from '@ngx-translate/core';

export interface ContentBlockedDialogData {
	message: string;
	featuredVideo?: FeaturedVideo;
	slug?: string;
}

@Component({
	selector: 'kwo-content-blocked',
	templateUrl: './content-blocked.component.html',
	styleUrls: ['./content-blocked.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, MatDialogModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockedComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<ContentBlockedComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ContentBlockedDialogData,
		private router: Router) { }

	ngOnInit(): void {

	}

	watchTrailer() {
		if (!this.data.featuredVideo?.trailer) {
			return;
		}
		this.dialogRef.close();
		this.router.navigateByUrl('/player/' + this.data.featuredVideo.trailer, { state: { type: VideoType.Trailer, slug: this.data.slug, title: this.data.featuredVideo.title } });
	}

	get hasTrailer(): boolean {
		return !!this.data.featuredVideo?.trailer;
	}

	navigateSubscribe() {

		this.router.navigate(['/aanmelden']);
	}

	goToLogin() {

		this.dialogRef.close();
		this.router.navigate(['/inloggen']);
	}
}